export const EXPORTSTS = {
  INPROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  COPY_READY: 'COPY_READY',
  FAILED: 'FAILED',
}
